import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {
  CheckboxFieldReduxFormWrapper,
  useApplicationContext,
} from '@adc/ui-adc'

const AuctionTypeFiltersContent = ({ elmId, className, submitForms }) => {
  const { featureFlags } = useApplicationContext()

  const offerLabel = featureFlags['fe.resi.enable-private-seller']
    ? 'Offer'
    : 'Direct Offer'
  const offerName = featureFlags['fe.resi.enable-private-seller']
    ? 'offer'
    : 'directOffer'
  return (
    <section data-elm-id={elmId} className={className}>
      <Field
        compact
        type='checkbox'
        name='online'
        elmId={`${elmId}_online`}
        onChange={submitForms}
        label='Online Auction'
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='live'
        elmId={`${elmId}_live`}
        onChange={submitForms}
        label='In Person Auction'
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='remoteBid'
        elmId={`${elmId}_remote_bid`}
        onChange={submitForms}
        label='Remote Bid'
        component={CheckboxFieldReduxFormWrapper}
      />
      <Field
        compact
        type='checkbox'
        name={offerName}
        elmId={`${elmId}_direct_offer`}
        onChange={submitForms}
        label={offerLabel}
        component={CheckboxFieldReduxFormWrapper}
      />
    </section>
  )
}

AuctionTypeFiltersContent.propTypes = {
  className: PropTypes.string,
  elmId: PropTypes.string.isRequired,
  submitForms: PropTypes.func.isRequired,
}

export default AuctionTypeFiltersContent
